import { BaseMenu } from "./base-menu";

export class ImportMenu extends BaseMenu {
    realm: boolean = false;
    endpoint: boolean = false;
    syndicate: boolean = false;
    cast: boolean = false;
}
